<div [@slideInOut] class="notification-wrap ad-spot-summary" [class.hidden]="hide | async" [class.default]="type === 'default'"
    [class.success]="type === 'success'" [class.danger]="type === 'danger'" [class.info]="type === 'info'">
    <div class="img-circle" *ngIf="imgSrc">
        <img [src]="imgSrc" alt="">
    </div>
    <div class="header-row">
        <div class="header-label">
            <div class="check-icon">
                <img src="/assets/icons/notification-icon.svg" />
            </div>
          Selected Ad Spot Details
        </div>
        <div class="button-group">
            <button class="second-btn" *ngIf="secondBtnContent" [class.danger-trans]="type === 'default'"
                [class.dark-trans-btn]="type !== 'default'"> {{secondBtnContent}} </button>
            <button class="main-btn" *ngIf="mainBtnContent" [class.primary-btn]="type === 'default'"
                [class.dark-btn]="type !== 'default'" (click)="mainBtnAction()"> {{mainBtnContent}} </button>
        </div> 
      </div>
           <!-- First row: 3 items -->
    <div class="summary-row">
      <div class="summary-item summary-inner">
        <div class="label">Ad spot</div>
        <div class="value">{{ selectedAdSlot }}</div>
      </div>
        <div class="summary-item summary-inner">
        <div class="label">No. of {{ daysOnDisplay === 1 ? 'Day' : 'Days' }}</div>
        <div class="value">{{ daysOnDisplay }}</div>
      </div>
      <div class="summary-item summary-inner">
        <div class="label">No. of Slot</div>
        <div class="value">{{ slotValue }}</div>
      </div>
       <div class="summary-item">
        <div class="label">Ad Spot Price</div>
        <div class="value">£{{ adSpotPrice | number:'1.1-2' }}</div>
      </div>
    </div>


      <!-- <div [@slideInOut] class="notification-wrap" [class.hidden]="hide | async" [class.default]="type === 'default'"
      [class.success]="type === 'success'" [class.danger]="type === 'danger'" [class.info]="type === 'info'">
      <div class="img-circle" *ngIf="imgSrc">
          <img [src]="imgSrc" alt="">
      </div>
      <div class="message-contents" *ngIf="message || subMessage">
          <div class="msg"> {{message}} </div>
          <div class="sub-msg"> {{subMessage}} </div>
      </div>
      <div class="button-group">
          <button class="second-btn" *ngIf="secondBtnContent" [class.danger-trans]="type === 'default'"
              [class.dark-trans-btn]="type !== 'default'"> {{secondBtnContent}} </button>
          <button class="main-btn" *ngIf="mainBtnContent" [class.primary-btn]="type === 'default'"
              [class.dark-btn]="type !== 'default'" (click)="mainBtnAction()"> {{mainBtnContent}} </button>
      </div> -->
</div>